<template>
  <v-menu
    ref="menu"
    v-model="menuDatePicker"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="formattedDate"
        :label="label"
        :prepend-inner-icon="prependIcon"
        readonly
        :dense="dense"
        :outlined="outlined"
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
        :error-messages="errorMessages"
        :rules="computedRules"
        :placeholder="placeholder"
        :clearable="clearable"
        @click:clear="clearDate"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="internalValue"
      :min="computedMinDate"
      :max="computedMaxDate"
      :locale="locale"
      no-title
      scrollable
      @input="onDateChange"
    >
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'DatePickerComponent',
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Data'
    },
    placeholder: {
      type: String,
      default: ''
    },
    prependIcon: {
      type: String,
      default: 'mdi-calendar'
    },
    dense: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    requiredMessage: {
      type: String,
      default: 'Campo obrigatório'
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    rules: {
      type: Array,
      default: () => []
    },
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    },
    maxDaysFromToday: {
      type: Number,
      default: null
    },
    minDaysFromToday: {
      type: Number,
      default: null
    },
    locale: {
      type: String,
      default: 'pt-br'
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY'
    }
  },
  data() {
    return {
      menuDatePicker: false,
      internalValue: this.value
    };
  },
  computed: {
    formattedDate() {
      return this.formatDate(this.internalValue);
    },
    computedRules() {
      const allRules = [...this.rules];
      
      if (this.required) {
        allRules.unshift(v => !!v || this.requiredMessage);
      }
      
      return allRules;
    },
    computedMaxDate() {
      if (this.maxDate) {
        return this.maxDate;
      }
      if (this.maxDaysFromToday) {
        const today = new Date();
        const max = new Date(today);
        max.setDate(today.getDate() + this.maxDaysFromToday);
        return max.toISOString().substr(0, 10);
      }
      return null;
    },
    computedMinDate() {
      if (this.minDate) {
        return this.minDate;
      }
      if (this.minDaysFromToday || this.minDaysFromToday === 0) {
        const today = new Date();
        const min = new Date(today);
        min.setDate(today.getDate() - this.minDaysFromToday);
        return min.toISOString().substr(0, 10);
      }
      return null;
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      
      const [year, month, day] = date.split('-');
      
      switch (this.format) {
        case 'DD/MM/YYYY':
          return `${day}/${month}/${year}`;
        case 'MM/DD/YYYY':
          return `${month}/${day}/${year}`;
        case 'YYYY-MM-DD':
          return date;
        default:
          return `${day}/${month}/${year}`;
      }
    },
    onDateChange() {
      this.menuDatePicker = false;
      this.$emit('input', this.internalValue);
      this.$emit('change', this.internalValue);
    },
    clearDate() {
      this.internalValue = null;
      this.$emit('input', null);
      this.$emit('change', null);
      this.$emit('clear');
    }
  }
};
</script>

<style scoped>
</style>
